import type { FC } from 'react';

import { ImageComponent } from '@/components/Image';

import { ScBadge } from './styled';

type BadgeType =
  | 'wagering'
  | 'top'
  | 'new'
  | 'tournament'
  | 'exclusive'
  | 'instant'
  | 'jackpot'
  | 'heart'
  | 'hot'
  | 'cold';

const MAP_CATEGORY_TO_ICON = {
  wagering: { src: '/wageringIcon.webp' }, // Circle
  exclusive: { src: '/exclusiveIcon.webp' }, // LUP
  top: { src: '/topIcon.webp' }, // Fire
  tournament: { src: '/tournamentIcon.webp' }, // Cup
  instant: { src: '/instantIcon.webp' }, // Lighting
  jackpot: { src: '/diamondIcon.webp' }, // Diamond
  heart: { src: '/emojis/heart.webp' }, // Heart
};

export interface IBadgeProps {
  type: BadgeType;
  className?: string;
  content?: string;
}

interface BadgeContentProps {
  type: BadgeType;
  content?: string;
}

export const BadgeContent: FC<BadgeContentProps> = ({ type, content }) => {
  switch (type) {
    case 'new':
      return <span>new</span>;
    case 'hot':
      return <span>{content}</span>;
    case 'cold':
      return <span>{content}</span>;
    default:
      return (
        <ImageComponent
          alt="badge"
          height={14}
          src={MAP_CATEGORY_TO_ICON[type]?.src}
          width={14}
        />
      );
  }
};

export const Badge: FC<IBadgeProps> = ({ type, className, content }) => (
  <ScBadge className={className} type={type}>
    <BadgeContent content={content} type={type} />
  </ScBadge>
);
